

const baseURL = "http://193.203.163.62:5000"; 

// const baseURL = "http://localhost:5000"; 


export default baseURL; 